import React, { useState, useEffect }  from "react";
// import Header from "./Instruments/Header";
import DecoderAdder from "./Instruments/DecoderAdder";
import CountryList from "./Instruments/CountryList";
import { useNavigate } from "react-router-dom";
import {Header, RegionList, SaveChanges} from "./../../../components/userPage";
import {LoadingModal} from './LoadModal';
import translate from './../../Translate/profilePage.json'
import { useLoading } from "./LoadModal/script";
import { getUser, getRegions } from '../../../shared/service';

const Profile = () => {
    const navigate = useNavigate()
    const nav = () => {
      navigate('/');
    }

    const [language, setLanguage] = useState('');
    
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const [id, setId] = useState(0);
    const [email, setEmail] = useState(null)
    const [name, setName] = useState(null);
    const [surname, setSurname] = useState(null)
    const [country, setCountry] = useState("cm");
    const [number, setNumber] = useState(null);
    const [reg, setReg] = useState(null);
    const handleEmailChange = (e) => {
      setEmail(e.target.value)
    }
    const handleNameChange = (e) => {
        setName(e.target.value);
    }
    const handleSurnameChange = (e) => {
        setSurname(e.target.value);
    }
    const handleNumberChange = (e) => {
        setNumber(e.target.value);
    }
    const countryListSave = (param) => {
      setCountry(param !== "" ? param : "cm" );
    }    

    const [savedRegionId, saveRegionId] = useState(2);
    const [regs, setRegs] = useState([]);
    const fetcher = async () => {
      try{
        const data = await getRegions();
        setRegs(data?.regions);
      }catch(e){
        console.error(e);
     }
    }

    const {loader} = useLoading();
    const fetchUser = async () => {

      try {
        const data = await getUser();
        setEmail(data?.email);
        setId(data?.id);
        setName(data?.name);
        setSurname(data?.surname);
        setCountry(data?.country);
        setReg(data?.region);
        setNumber(data?.phone);
      } catch (error) {
        nav();
      }
    };
    useEffect(() => {
      loader(true)
      setLanguage(JSON.parse(localStorage.getItem('choosen-language')))
      fetchUser();
      fetcher();
      setTimeout(() => {
        loader(false)
      }, 700)
    }, [navigate]); 
  
    useEffect(() => {
      regs?.forEach(el => {
        if(el?.region_name === reg) saveRegionId(el?.region_id);
      })
    }, [reg, regs]); 
    return(
      <div className="user-menu-profile">
            <Header />
            <div className="user-body">
                <LoadingModal/>
                <div className="user-profile-body-in">
                  <div className="user-profile-block">
                      <div className="user-profile-block-container">
                          <div className="user-profile-right-column">
                              <p className="columnize">User ID: {id}</p>
                              <p className="columnize">Email:
                                <input 
                                  className="user-info-input"
                                  type="text" 
                                  value={email} 
                                  onChange={handleEmailChange}/>
                              </p>
                              <p className="columnize">{translate.prase1[language]} <input 
                                  className="user-info-input"
                                  type="text" 
                                  value={name} 
                                  onChange={handleNameChange}/>
                              </p>
                              <p className="columnize">{translate.prase2[language]} <input 
                                  className="user-info-input"
                                  type="text" 
                                  value={surname} 
                                  onChange={handleSurnameChange}/>
                              </p>
                              <p><CountryList saveCountry={countryListSave} countryOnLoad={country || ''} multilingua={translate.prase3[language]} language={language}/></p>
                              <p><RegionList saveRegionId={saveRegionId} regs={regs} region={reg} id={savedRegionId} /></p>
                             
                              
                              <p className="columnize">{translate.prase4[language]} <input 
                                  className="user-info-input"
                                  type="text" 
                                  value={number}  
                                  onChange={handleNumberChange}/>
                              </p>

                          </div>
                          <div className="user-profile-right-column">
                              <p><a href="password-change" style={{color: "#2C3930"}}>{translate.prase5[language]}</a></p>
                              <p>{translate.prase6[language]} </p>
                              <DecoderAdder translate={translate} language={language}/>
                              <SaveChanges prase={translate.prase7[language]} dataToSend={{
                                email: email || '',
                                phone: number || '',
                                name: name || '',
                                surname: surname || '',
                                country: country || "cm",
                                region_id: savedRegionId || 0,
                                timezone: timezone,
                              }} fetchUser={fetchUser} fetcher={fetcher}/>
                          </div>
                      </div>
                  </div>
                </div>
            </div>  
        </div>
    )
}
export default Profile;